var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"general_wrapper"},[(_vm.period)?_c('div',{staticClass:"tracker_wrapper"},[_c('TrackerHead'),(_vm.servers)?_c('TrackerTable'):_vm._e()],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }